import { Box, Button, Typography } from '@mui/material'
import { FC } from 'react'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'

export type MaxMembersReachedModalProps = {
  open: boolean
  onClose: () => void
}

export const MaxMembersReachedModal: FC<MaxMembersReachedModalProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation('consoleFavoriteMemberSettings')

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('maxMembersReachedModalTitle')}
      innerSx={{
        width: 300,
      }}
      content={
        <>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: 13,
              fontWeight: 300,
            }}
          >
            {t('maxMembersReachedDescription')}
          </Typography>

          <Box sx={{ mt: 4 }}>
            <Button variant="text" onClick={onClose} fullWidth>
              {t('close')}
            </Button>
          </Box>
        </>
      }
    />
  )
}
